import { render, staticRenderFns } from "./Accessorials.vue?vue&type=template&id=528b5063&scoped=true"
import script from "./Accessorials.vue?vue&type=script&lang=js"
export * from "./Accessorials.vue?vue&type=script&lang=js"
import style0 from "./Accessorials.vue?vue&type=style&index=0&id=528b5063&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528b5063",
  null
  
)

export default component.exports